<template>
  <div class="section-header">
    <div class="section-header__accent"></div>
    <span class="section-header__title">{{ title }}</span>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    title: string;
  }>();
</script>

<style scoped>
  .section-header {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 21px;
  }

  .section-header__accent {
    width: 3px;
    height: 20px;
    background-color: #6033e1;
    border-radius: 9999px;
    flex-shrink: 0;
  }

  .section-header__title {
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #1e293b;
  }
</style>
